import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgMagnifier = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21.52 2.48A8.45 8.45 0 0 0 8.57 13.23l-8.11 8.1a1.57 1.57 0 0 0 2.21 2.22l8.11-8.12A8.45 8.45 0 0 0 21.52 2.48m-2.21 9.75a5.47 5.47 0 0 1-7.54 0 5.34 5.34 0 1 1 7.55 0Z"
    }));
export default SvgMagnifier;
